import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@popperjs/core';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Function to dynamically load external scripts
//function loadScript(src, integrity, crossorigin) {
//  const script = document.createElement("script");
//  script.src = src;
//  if (integrity) script.integrity = integrity;
//  if (crossorigin) script.crossOrigin = crossorigin;
//  script.async = true;
//  document.head.appendChild(script);
//}
//
//// Load external scripts
//loadScript("https://code.jquery.com/jquery-3.5.1.slim.min.js", null, "anonymous");
//loadScript("https://cdn.jsdelivr.net/npm/@popperjs/core@2.5.4/dist/umd/popper.min.js");
//loadScript("https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
